import { z } from 'zod';
import { BootService } from '@/services/boot';
import { ServiceError } from '@/types/service';
import { Result } from '@/types/common';
import * as Type from '@/types/talonone';
import { requestHandler, responseHandler } from '@/utilities/service';

export async function getTalononePromoResponse(
  clientId: string,
  page: number,
  pageSize: number,
): Promise<Type.TalonOnePromoResponse> {
  // page index start at 1
  const offset = page > 0 ? (page - 1) * pageSize : 0;

  const path = `/coupons?customerId=${clientId}&offset=${offset}&limit=${pageSize}`;
  const res = await BootService.axios.get<Type.TalonOnePromoResponse>(path);
  return res.data;
}

export async function getTalononeCampaigns(): Promise<Result<ServiceError, Type.TalonOneCampaign[]>> {
  const path = `/campaigns`;
  return requestHandler(BootService.axios.get(path).then(responseHandler(Type.TalonOneCampaignSchema.array())));
}

export type NewPromoCodeData = {
  campaignId: number;
  customerEmail: string;
  expiryDateTime: string;
  mov?: number;
  currency?: string;
  amount?: number;
  percent?: number;
  couponDiscountType?: 'flat' | 'percentage';
  clientId: string;
};
export async function createNewPromoCode(data: NewPromoCodeData): Promise<Result<ServiceError, Type.TalonOnePromo>> {
  return requestHandler(
    BootService.axios
      .post(`/campaigns/${data.campaignId}/coupons`, data)
      .then(responseHandler(Type.TalonOnePromoSchema)),
  );
}

export type ExtendPromoCodeData = {
  campaignId: number;
  expiryDateTime: string;
  couponCode: string;
  clientId: string;
};
export async function extendPromoCode(data: ExtendPromoCodeData): Promise<Result<ServiceError, unknown>> {
  return requestHandler(
    BootService.axios
      .put(`/campaigns/${data.campaignId}/coupons/${data.couponCode}/expiry-date`, data)
      .then(responseHandler(z.unknown())),
  );
}

export type DisablePromoCodeData = {
  campaignId: number;
  couponId: string;
  clientId: string;
};
export async function disablePromoCode(data: DisablePromoCodeData): Promise<Result<ServiceError, unknown>> {
  return requestHandler(
    BootService.axios
      .post(`/campaigns/${data.campaignId}/coupons/${data.couponId}/disable`, { clientId: data.clientId })
      .then(responseHandler(z.unknown())),
  );
}
